import React from 'react';
import { Specialty } from 'types/specialty';
import SpecialtyItemModule from './SpecialtyItemModule';
import List from 'components/list/List';

type SpecialtyListModuleProps = {
  specialties: Specialty[];
  handleSearch: () => void;
};

const SpecialtyListModule: React.FC<SpecialtyListModuleProps> = ({ specialties, handleSearch }) => {
  return (
    <List>
      {specialties.map(specialty => (
        <SpecialtyItemModule handleSearch={handleSearch} key={specialty.id} specialty={specialty} />
      ))}
    </List>
  );
};

export default SpecialtyListModule;
